
<!--
 * @Author: your name
 * @Date: 2021-04-15 11:24:30
 * @LastEditTime: 2021-08-10 17:15:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\App.vue
-->

<template>
  <div id="app">
    <!--    <div id="nav">-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </div>-->
    <van-overlay :show="isBtnShow">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" text-color="#0094ff" vertical>请稍等...{{isBtnShow}}</van-loading>
      </div>
    </van-overlay>
    <!-- 需要缓存的路由出口 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 不需要缓存的路由出口 -->
    <router-view v-if="!$route.meta.keepAlive" />
    <van-popup
      :close-on-click-overlay="false"
      v-model="islisShow"
      position="bottom"
      :style="{ height: '25%',borderRadius: '10px 10px 0 0' }"
    >
      <div class="toGrant">
        <h2 class="title">邀请授权</h2>
        <div class="subTitle">获取你的昵称,头像,地区及性别</div>
        <div class="what">
          <!-- <div class="sc" @click="overlayContent" style="background:#EDEDED;color:#0CC060">取消授权</div> -->
          <div class="sc" @click="weixinFg" style="background:#0CC060;color:#fff">立即授权</div>
        </div>
      </div>
    </van-popup>
    <!-- 开启底部安全区适配 -->
    <!-- <van-number-keyboard safe-area-inset-bottom /> -->
  </div>
</template>

<script>
import { Toast } from 'vant'
import { weixinFg } from '@/public/public' //微信授权
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      isPopupText: false,
      islisShow: false,
      isPopupName: '',
      app_id: '',
      istok: '',
      isBtnShow: false,
      path: [
        '/',
        '/home',
        '/giftBig',
        '/shopDetails',
        '/activeShopDetail',
        '/dynamicDetails',
        '/delivery',
        '/unionCard',
        '/homeIndex',
      ],
      navList: [],
    }
  },
  created() {
    ;(function () {
      if (
        typeof WeixinJSBridge == 'object' &&
        typeof WeixinJSBridge.invoke == 'function'
      ) {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            handleFontSize,
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize)
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
        }
      }
      function handleFontSize() {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 16 })
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 16 })
        })
      }
    })()
    this.getAppIdFg()
    this.isPopupText = this.$store.state.isPopupText
    let search = window.location.href.split('?')[1]
      ? window.location.href.split('?')[1].split('code=')[1]
      : ''
    if (
      search &&
      (!JSON.parse(localStorage.getItem('isToken')) ||
        localStorage.getItem('isToken') == null)
    ) {
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = localStorage
        .getItem('locationHref')
        .substr(localStorage.getItem('locationHref').indexOf('?') + 1)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      console.log(str)
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      if (obj.uid) {
        this.share_usesr_id = obj.uid
      }
      //从地址栏去code 有就调取 getOpenid() 方法
      this.getOpenid(search.indexOf('&') > -1 ? search.split('&')[0] : search)
    }
    //  else {
    //   this.onceCode = ''
    //   this.getOpenid()
    // }
  },
  mounted() {
    // this.prohibitweixinShare()
  },
  watch: {
    listenComponentState(newval, oldval) {
      this.isPopupText = newval.isPopupText
      this.isPopupName = newval.isPopupName
      if (newval.isPopupName) {
        Toast(newval.isPopupName)
      }
      this.$store.commit('increment', '')
    },
    LoginFailure(newval) {
      console.log(newval, 'newval')
      //监听授权
      this.islisShow = newval.islisShow
    },
    $route: {
      handler(newRouter) {
        console.log(newRouter)
        wx.hideAllNonBaseMenuItem()
        if (
          newRouter.path == '/homeIndex' ||
          newRouter.path == '/social' ||
          newRouter.path == '/website' ||
          newRouter.path == '/dynamic' ||
          newRouter.path == '/my'
        ) {
          this.getNavList()
        }
      },
      immediate: true,
      deep: true,
    },
    navList(newval) {},
  },
  methods: {
    async getNavList() {
      let res = await this.http('Client.navList', {})
      this.navList = res.content.list
      this.$store.commit('navFg', res.content.list)
      console.log(res, '=====---****---')
    },
    //判断白名单
    // 兼容返回
    async getAppIdFg() {
      let { content } = await this.http('Base.getMerchantInfo')
      console.log(content, '*-*')
      localStorage.setItem('chantInfo', content.pay_url)
      localStorage.setItem('mechId', content.merchant_id)
      localStorage.setItem('appId', content.app_id)
      localStorage.setItem('follow_thumb', content.follow_thumb)
      localStorage.setItem('domain', content.domain)
      this.app_id = content.app_id
    },
    weixinFg() {
      this.$store.commit('LoginFailure', false)
      if (this.$router.history.current.fullPath != '/login') {
        localStorage.setItem('locationHref', window.location.href)
      } else {
        localStorage.setItem('locationHref', '')
      }
      weixinFg(
        localStorage.getItem('httpsConfig') + '.cn/yj_project/#/',
        // window.location.href.split('?')[0],
        this.app_id
      )
    },
    getOpenid(key) {
      if (JSON.stringify(localStorage.getItem('isToken')) == true) {
        return
      }
      //用code 换取token
      this.onceCode = key
      this.http('Base.wxLogin', {
        code: key,
        share_user_id: this.share_usesr_id, //绑定关系
        share_staff_id: 0, //绑定关系
      }).then((res) => {
        if (res.status == 200) {
          // res.content.mobile
          //   ?
          localStorage.setItem(
            'store_id',
            res.content.alliance_store && res.content.alliance_store.store_id
              ? res.content.alliance_store.store_id
              : ''
          )
          localStorage.setItem(
            'staff_id',
            res.content.alliance_store && res.content.alliance_store.staff_id
              ? res.content.alliance_store.staff_id
              : ''
          )
          window.location.href = localStorage.getItem('locationHref')
          //   ? (window.location.href = localStorage.getItem('locationHref'))
          //   : this.$router.push({ path: 'home' })
          // : (this.is_load = false)
        } else if (res) {
          if (res.status == 600) {
            //为600 code失效  每个code只能用一次
            this.$store.commit('LoginFailure', true) //弹框再次授权
          }
        }
      })
    },
    // 取消
    overlayContent() {
      //暂不授权啊
      this.$store.commit('activeFailure', 0)
      this.$store.commit('LoginFailure', false)
      this.$router.push({ path: '/home' })
    },
  },
  computed: {
    listenComponentState() {
      //提示框
      return {
        isPopupText: this.$store.state.isPopupText,
        isPopupName: this.$store.state.isPopupName,
      }
    },
    LoginFailure() {
      //登陆失败弹窗
      let search = window.location.href.split('?')[1]
        ? window.location.href.split('?')[1].split('code=')[1]
        : false
      console.log(search, 'searchsearch')
      return {
        islisShow:
          this.$store.state.LoginFailure &&
          (!search || JSON.stringify(localStorage.getItem('isToken')) == false),
      }
    },
  },
}
</script>
<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
<style>
body {
  /* IOS禁止微信调整字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
.n_footer {
  height: 100px;
}
body {
  padding: 0;
  margin: 0;
  color: #323232;
  font-family: PingFang SC !important;
}
.mt20 {
  margin-top: 20px !important;
}
#app {
  font-family: PingFang SC !important;
}
.red {
  color: #f0240e !important;
}
.mt10 {
  margin-top: 10px;
}
.loading_box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.lodding_l {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 100px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  text-align: center;
  border-radius: 10px;
}
b {
  font-weight: normal;
}
em {
  font-style: normal;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 0.58rem;
  font-weight: normal;
}

strong,
b {
  font-weight: normal;
}

em,
i,
p {
  font-style: normal;
}

a {
  text-decoration: none;
  color: #000;
}
.mod {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 988;
}
.load {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 2001;
  background: #fff;
  left: 0;
  top: 0;
}
.toGrant {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 20px 0 0 20px;
}
.toGrant .title {
  font-size: 25px;
  font-family: bold;
}
.toGrant .subTitle {
  font-size: 30px;
  font-family: bold;
  padding-top: 10px;
}
.toGrant .what {
  display: flex;
  justify-content: center;
  padding-top: 50px;
}
.toGrant .what .sc {
  border-radius: 5px;
  background: red;
  height: 80px;
  width: 200px;
  text-align: center;
  margin: 0 20px;
  font-size: 24px;
  line-height: 80px;
}
.van-step__icon--active {
  color: #ff8737 !important;
}
.van-step__title--active {
  color: #333 !important;
}

.van-step__title p,
.van-step__title--active p {
  margin-top: 20px !important;
  font-size: 24px !important;
  color: #999 !important;
}
.fl {
  float: left !important;
}
.fr {
  float: right !important;
}
/*首页轮播图圆角*/
.zn_banner_index .van-image__img {
  border-radius: 15px !important;
}
.zn_banner_index .van-swipe-item {
  background: none !important;
  /*0618 修改样式*/
  /*height: 100% !important;*/
}
.zn_banner_index .van-image {
  /*0618 修改样式*/
  width: 100% !important;
}
.ProductList .van-tab__text {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
}
.shop_detailsbanner .van-swipe__indicator {
  color: #ff3b30 !important;
  background: #000 !important;
}
</style>
